// import { faPlus } from "@fortawesome/pro-light-svg-icons";
// import React, { useContext, useEffect, useState } from "react";
// import DeleteModal from "src/components/DeleteModal";
// import styled from "styled-components";
// import { v4 as uuidv4 } from "uuid";
// import Button from "../../../components/Button";
// import SinglePhotoUpload from "../../../components/PhotoUpload/Single";
// import SelectSearch from "../../../components/SelectSearch";
// import FirebaseStorageService from "../../../services/Firebase/storage";
// import { Client } from "../../../types";
// import { ClientContactFormProps, KleenwayContactFormProps } from "../ClientDetailsProvider";
// import ClientDetailsContext from "../context";
// import { ClientContactForm, InputRow, InputsRow } from "./ClientContactForm";
// import { KleenwayContactForm } from "./KleenwayContactForm";

// export const getLogoPropType = (logo: File | string) => (typeof logo === "string" ? "fileName" : "file");

// export const GeneralInfoForm = ({ client: { name, address, inactive } }: { client: Client }) => {
//   const { generalInfoFormState, setGeneralInfoFormState, timezones, isContextLoaded, dropdownListSizes } =
//     useContext(ClientDetailsContext);

//   const [contactFormToDelete, setContactFormToDelete] = useState<string>("");
//   const [kleenwayContactFormToDelete, setKleenwayContactFormToDelete] = useState<string | boolean>("");
//   const [loading, setLoading] = useState<boolean>(true);
//   const [logo, setLogo] = useState<File | string | null>(null);

//   const getLogoDownloadUrl = (logoFileName: string) =>
//     FirebaseStorageService.getDownloadURL(process.env.REACT_APP_CLIENT_LOGO_FOLDER, logoFileName)
//       .then(({ data: logoDownloadUrl }) => setLogo(logoDownloadUrl))
//       .catch((error) => console.log(error))
//       .finally(() => setLoading(false));

//   useEffect(() => {
//     if (generalInfoFormState) {
//       const { logo: clientLogo } = generalInfoFormState;

//       if (clientLogo) {
//         const typeOfLogoProp = getLogoPropType(clientLogo);
//         if (typeOfLogoProp === "fileName") {
//           const logoFileName = clientLogo as string;
//           getLogoDownloadUrl(logoFileName);
//         } else {
//           setLogo(clientLogo);
//           setLoading(false);
//         }
//       } else {
//         setLoading(false);
//       }
//     }
//   }, [generalInfoFormState?.logo]);

//   if (loading) {
//     return null;
//   }
//   const onDeleteContact = () => {
//     setGeneralInfoFormState(({ clientContacts, ...prevState }) => ({
//       ...prevState,
//       clientContacts: clientContacts.filter(({ id: formId }) => formId !== contactFormToDelete),
//     }));
//     setContactFormToDelete("");
//   };

//   const onDeleteKleenwayContact = () => {
//     setGeneralInfoFormState(({ kleenwayContacts, ...prevState }) => ({
//       ...prevState,
//       kleenwayContacts: kleenwayContacts.filter(
//         ({ formId: contactFormId }) => contactFormId !== kleenwayContactFormToDelete,
//       ),
//     }));
//     setKleenwayContactFormToDelete("");
//   };

//   return (
//     <div>
//       <DeleteModal
//         onApproveClick={onDeleteContact}
//         onCancelClick={() => setContactFormToDelete("")}
//         title="Contact"
//         isShowing={Boolean(contactFormToDelete)}
//         hide={() => setContactFormToDelete("")}
//       />
//       <DeleteModal
//         onApproveClick={onDeleteKleenwayContact}
//         onCancelClick={() => setKleenwayContactFormToDelete("")}
//         title="Contact"
//         isShowing={Boolean(kleenwayContactFormToDelete)}
//         hide={() => setKleenwayContactFormToDelete("")}
//       />
//       <SinglePhotoUpload
//         setFile={(file: File | null) => {
//           setGeneralInfoFormState((prevState) => ({
//             ...prevState,
//             logo: file,
//           }));
//           setLogo(file);
//         }}
//         file={logo}
//         elementName="Logo"
//       />
//       <OneRowWrapper>
//         <label>Name: </label>
//         <RowValue>{name}</RowValue>
//       </OneRowWrapper>
//       {address && (
//         <OneRowWrapper>
//           <label>Address: </label>
//           <RowValue>{address}</RowValue>
//         </OneRowWrapper>
//       )}

//       <InputsRow>
//         {inactive !== undefined && (
//           <InputRow>
//             <label>Status: </label>
//             <RowValue>{inactive ? "Inactive" : "Active"}</RowValue>
//           </InputRow>
//         )}
//         {isContextLoaded && (
//           <InputRow>
//             <label>Time Zone: </label>
//             <SelectSearch
//               defaultValue={
//                 timezones.some((item) => item.id === generalInfoFormState?.timezone?.id)
//                   ? generalInfoFormState?.timezone?.id
//                   : 0
//               }
//               placeholder="Select timezone"
//               options={timezones}
//               onChange={(item) => {
//                 setGeneralInfoFormState((prevState) => ({
//                   ...prevState,
//                   timezone: item,
//                 }));
//               }}
//               listSize={dropdownListSizes?.timezone}
//             />
//           </InputRow>
//         )}
//       </InputsRow>
//       <FormsContainer>
//         {generalInfoFormState?.clientContacts?.map(({ id }, index) => (
//           <ClientContactForm
//             key={id}
//             formIndex={index}
//             defaultValues={generalInfoFormState?.clientContacts?.[index]}
//             handleFormDelete={() => setContactFormToDelete(id)}
//           />
//         ))}
//       </FormsContainer>
//       <Button
//         text="Add Client Contact"
//         variant="dotted-border"
//         icon={faPlus as any}
//         onClick={() =>
//           setGeneralInfoFormState(({ clientContacts = [], ...prevState }) => ({
//             ...prevState,
//             clientContacts: [
//               ...clientContacts,
//               {
//                 id: uuidv4(),
//                 isValid: false,
//               } as ClientContactFormProps,
//             ],
//           }))
//         }
//       />
//       <FormsContainer>
//         {generalInfoFormState?.kleenwayContacts?.map(({ formId }, index) => (
//           <KleenwayContactForm
//             key={formId}
//             formIndex={index}
//             handleFormDelete={() => setKleenwayContactFormToDelete(formId)}
//           />
//         ))}
//       </FormsContainer>
//       <Button
//         text="Add Kleenway Contact"
//         variant="dotted-border"
//         icon={faPlus as any}
//         onClick={() =>
//           setGeneralInfoFormState(({ kleenwayContacts = [], ...prevState }) => ({
//             ...prevState,
//             kleenwayContacts: [
//               ...kleenwayContacts,
//               {
//                 formId: uuidv4(),
//                 isValid: false,
//               } as KleenwayContactFormProps,
//             ],
//           }))
//         }
//       />
//     </div>
//   );
// };

// const FormsContainer = styled.div`
//   margin-bottom: 30px;
// `;

// export const RowValue = styled.p`
//   width: 175px;
//   font-weight: 400;
//   font-size: 14px;
//   font-style: unset;
//   color: unset;
// `;

// const OneRowWrapper = styled(InputRow)`
//   width: 100%;
//   max-width: unset;
//   & > p {
//     width: 100%;
//   }
//   & > label {
//     width: 135px;
//     font-weight: 600;
//   }
// `;

import React, { useContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import DeleteModal from "src/components/DeleteModal";
import SinglePhotoUpload from "../../../components/PhotoUpload/Single";
import SelectSearch from "../../../components/SelectSearch";
import FirebaseStorageService from "../../../services/Firebase/storage";
import { Client } from "../../../types";
import { ClientContactFormProps, KleenwayContactFormProps } from "../ClientDetailsProvider";
import ClientDetailsContext from "../context";
import { ClientContactForm } from "./ClientContactForm";
import { KleenwayContactForm } from "./KleenwayContactForm";
import styled from "styled-components";
import { ButtonHTMLAttributes, ReactNode } from "react";

// ─── Inlined Kori UI primitives ───────────────────────────────────────────────

function Panel({ title, meta, children }: { title?: string; meta?: ReactNode; children: ReactNode }) {
  return (
    <PanelWrapper>
      {(title || meta) && (
        <PanelHeader>
          <PanelTitle>{title}</PanelTitle>
          {meta && <PanelMeta>{meta}</PanelMeta>}
        </PanelHeader>
      )}
      <div>{children}</div>
    </PanelWrapper>
  );
}

function EmptyRow({ children = "No items" }: { children?: ReactNode }) {
  return <EmptyRowWrapper>{children}</EmptyRowWrapper>;
}

type KButtonVariant = "primary" | "outline" | "ghost";
type KButtonSize = "sm" | "md" | "lg";

function KButton({
  variant = "primary",
  size = "md",
  children,
  ...rest
}: {
  variant?: KButtonVariant;
  size?: KButtonSize;
  children: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <StyledKButton $variant={variant} $size={size} {...rest}>
      {children}
    </StyledKButton>
  );
}

// ─── Local shared primitives ──────────────────────────────────────────────────

export const getLogoPropType = (logo: File | string) => (typeof logo === "string" ? "fileName" : "file");

function Field({ label, full, children }: { label: string; full?: boolean; children: ReactNode }) {
  return (
    <FieldWrapper $full={full}>
      <FieldLabel>{label}</FieldLabel>
      <FieldValue>{children}</FieldValue>
    </FieldWrapper>
  );
}

function contactCount(n: number) {
  return `${String(n).padStart(2, "0")} on file`;
}

// ─── Component ────────────────────────────────────────────────────────────────

export const GeneralInfoForm = ({
  client: {
    name,
    companyName,
    customerId,
    status,
    address,
    email,
    phone,
    accountManager,
    customerPortalAccess,
    portalLoginEmail,
    inactive,
  },
}: {
  client: Client;
}) => {
  const { generalInfoFormState, setGeneralInfoFormState, timezones, isContextLoaded, dropdownListSizes } =
    useContext(ClientDetailsContext);

  const [contactFormToDelete, setContactFormToDelete] = useState<string>("");
  const [kleenwayContactFormToDelete, setKleenwayContactFormToDelete] = useState<string | boolean>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [logo, setLogo] = useState<File | string | null>(null);

  const getLogoDownloadUrl = (logoFileName: string) =>
    FirebaseStorageService.getDownloadURL(process.env.REACT_APP_CLIENT_LOGO_FOLDER, logoFileName)
      .then(({ data: logoDownloadUrl }) => setLogo(logoDownloadUrl))
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));

  useEffect(() => {
    if (generalInfoFormState) {
      const { logo: clientLogo } = generalInfoFormState;
      if (clientLogo) {
        if (getLogoPropType(clientLogo) === "fileName") {
          getLogoDownloadUrl(clientLogo as string);
        } else {
          setLogo(clientLogo);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    }
  }, [generalInfoFormState?.logo]);

  if (loading) return null;

  const onDeleteContact = () => {
    setGeneralInfoFormState(({ clientContacts, ...prevState }) => ({
      ...prevState,
      clientContacts: clientContacts.filter(({ id: formId }) => formId !== contactFormToDelete),
    }));
    setContactFormToDelete("");
  };

  const onDeleteKleenwayContact = () => {
    setGeneralInfoFormState(({ kleenwayContacts, ...prevState }) => ({
      ...prevState,
      kleenwayContacts: kleenwayContacts.filter(
        ({ formId: contactFormId }) => contactFormId !== kleenwayContactFormToDelete,
      ),
    }));
    setKleenwayContactFormToDelete("");
  };

  const clientContactCount = generalInfoFormState?.clientContacts?.length ?? 0;
  const kleenwayContactCount = generalInfoFormState?.kleenwayContacts?.length ?? 0;

  return (
    <Wrapper>
      <DeleteModal
        onApproveClick={onDeleteContact}
        onCancelClick={() => setContactFormToDelete("")}
        title="Contact"
        isShowing={Boolean(contactFormToDelete)}
        hide={() => setContactFormToDelete("")}
      />
      <DeleteModal
        onApproveClick={onDeleteKleenwayContact}
        onCancelClick={() => setKleenwayContactFormToDelete("")}
        title="Contact"
        isShowing={Boolean(kleenwayContactFormToDelete)}
        hide={() => setKleenwayContactFormToDelete("")}
      />

      {/* Logo */}
      <SinglePhotoUpload
        setFile={(file: File | null) => {
          setGeneralInfoFormState((prevState) => ({ ...prevState, logo: file }));
          setLogo(file);
        }}
        file={logo}
        elementName="Logo"
      />

      {/* General Info */}
      <Panel title="General Info">
        <FieldGrid>
          <Field label="Name">{name}</Field>

          <Field label="Company Name">{companyName || "—"}</Field>

          <Field label="Customer ID">{customerId || "—"}</Field>

          <Field label="Status">{status || (inactive ? "Inactive" : "Active")}</Field>

          <Field label="Account Manager">{accountManager || "—"}</Field>

          <Field label="Portal Access">{customerPortalAccess ? "Enabled" : "Disabled"}</Field>

          <Field label="Portal Login Email">{portalLoginEmail || "—"}</Field>

          <Field label="Email">{email || "—"}</Field>

          <Field label="Phone">{phone || "—"}</Field>

          {address && (
            <Field label="Address" full>
              {address}
            </Field>
          )}

          {isContextLoaded && (
            <Field label="Time Zone">
              <SelectSearch
                defaultValue={
                  timezones.some((item) => item.id === generalInfoFormState?.timezone?.id)
                    ? generalInfoFormState?.timezone?.id
                    : 0
                }
                placeholder="Select timezone"
                options={timezones}
                onChange={(item) =>
                  setGeneralInfoFormState((prevState) => ({
                    ...prevState,
                    timezone: item,
                  }))
                }
                listSize={dropdownListSizes?.timezone}
              />
            </Field>
          )}
        </FieldGrid>
      </Panel>

      {/* Client Contacts */}
      <Panel title="Client Contacts" meta={contactCount(clientContactCount)}>
        {clientContactCount === 0 ? (
          <EmptyRow>No client contacts added yet.</EmptyRow>
        ) : (
          <ContactList>
            {generalInfoFormState?.clientContacts?.map(({ id }, index) => (
              <ContactRow key={id}>
                <ClientContactForm
                  formIndex={index}
                  defaultValues={generalInfoFormState?.clientContacts?.[index]}
                  handleFormDelete={() => setContactFormToDelete(id)}
                />
              </ContactRow>
            ))}
          </ContactList>
        )}
        <PanelFooter>
          <KButton
            variant="outline"
            onClick={() =>
              setGeneralInfoFormState(({ clientContacts = [], ...prevState }) => ({
                ...prevState,
                clientContacts: [...clientContacts, { id: uuidv4(), isValid: false } as ClientContactFormProps],
              }))
            }
          >
            + Add Client Contact
          </KButton>
        </PanelFooter>
      </Panel>

      {/* Kleenway Contacts */}
      <Panel title="Kleenway Contacts" meta={contactCount(kleenwayContactCount)}>
        {kleenwayContactCount === 0 ? (
          <EmptyRow>No Kleenway contacts added yet.</EmptyRow>
        ) : (
          <ContactList>
            {generalInfoFormState?.kleenwayContacts?.map(({ formId }, index) => (
              <ContactRow key={formId}>
                <KleenwayContactForm
                  formIndex={index}
                  handleFormDelete={() => setKleenwayContactFormToDelete(formId)}
                />
              </ContactRow>
            ))}
          </ContactList>
        )}
        <PanelFooter>
          <KButton
            variant="outline"
            onClick={() =>
              setGeneralInfoFormState(({ kleenwayContacts = [], ...prevState }) => ({
                ...prevState,
                kleenwayContacts: [
                  ...kleenwayContacts,
                  { formId: uuidv4(), isValid: false } as KleenwayContactFormProps,
                ],
              }))
            }
          >
            + Add Kleenway Contact
          </KButton>
        </PanelFooter>
      </Panel>
    </Wrapper>
  );
};

// ─── Styled components ────────────────────────────────────────────────────────

// Layout
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

// Panel
const PanelWrapper = styled.section`
  border: 1px solid #e4e4e7;
  background: #fafaf9;
`;

const PanelHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  border-bottom: 1px solid #e4e4e7;
`;

const PanelTitle = styled.span`
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #71717a;
`;

const PanelMeta = styled.span`
  font-size: 10px;
  font-weight: 300;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #71717a;
`;

// EmptyRow
const EmptyRowWrapper = styled.div`
  padding: 24px 16px;
  text-align: center;
  font-size: 12px;
  font-weight: 300;
  color: #71717a;
`;

// KButton
const sizeStyles: Record<KButtonSize, string> = {
  sm: "padding: 6px 12px; font-size: 10px;",
  md: "padding: 8px 14px; font-size: 10px;",
  lg: "padding: 10px 16px; font-size: 11px;",
};

const variantStyles: Record<KButtonVariant, string> = {
  primary: `
    background: #18181b;
    color: #fafaf9;
    border: 1px solid #27272a;
    &:hover:not(:disabled) { background: #09090b; }
  `,
  outline: `
    background: transparent;
    color: #27272a;
    border: 1px solid #27272a;
    &:hover:not(:disabled) { background: #f4f4f5; }
  `,
  ghost: `
    background: transparent;
    color: #71717a;
    border: none;
    &:hover:not(:disabled) { background: #f4f4f5; }
  `,
};

const StyledKButton = styled.button<{ $variant: KButtonVariant; $size: KButtonSize }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  cursor: pointer;
  transition: none;
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
  ${({ $variant }) => variantStyles[$variant]}
  ${({ $size }) => sizeStyles[$size]}
`;

// Field
const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 24px;
  padding: 24px;
`;

const FieldWrapper = styled.div<{ $full?: boolean }>`
  ${({ $full }) => $full && "grid-column: 1 / -1;"}
`;

const FieldLabel = styled.div`
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #71717a;
  margin-bottom: 4px;
`;

const FieldValue = styled.div`
  font-size: 13px;
  color: #18181b;
`;

// Contacts
const ContactList = styled.div`
  & > * + * {
    border-top: 1px solid #e4e4e7;
  }
`;

const ContactRow = styled.div`
  padding: 16px;
`;

const PanelFooter = styled.div`
  padding: 16px;
  border-top: 1px solid #e4e4e7;
`;

// Re-exported for use in LocationDetails/GeneralInfoForm
export const RowValue = styled.div`
  font-size: 13px;
  color: #18181b;
  font-weight: 400;
`;
